import { render, staticRenderFns } from "./SelectableOrders.vue?vue&type=template&id=b6116488&"
import script from "./SelectableOrders.vue?vue&type=script&lang=ts&"
export * from "./SelectableOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports